import {SxType} from "@baseTypes/sx/sxTypes";
import {SV_DARK, SV_LIGHT, SV_RADIUS_SM, SV_TRANSITION} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    root: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '9px',
        padding: '8px 9px',
        borderRadius: SV_RADIUS_SM,
        textAlign: 'left',
        transition: SV_TRANSITION,
        '.lightTheme &:hover': {
            backgroundColor: SV_LIGHT.accentSoft,
        },
        '.darkTheme &:hover': {
            backgroundColor: SV_DARK.accentSoft,
        },
        '&:hover .chevron, &:focus-visible .chevron': {
            opacity: 1,
        },
    },
    stop: {
        display: 'flex',
        alignItems: 'center',
        gap: '7px',
        flex: 1,
        minWidth: 0,
    },
    number: {
        width: '25px',
        height: '25px',
        borderRadius: '50%',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        fontWeight: 700,
        '.lightTheme &': {
            backgroundColor: SV_LIGHT.accent,
            color: SV_LIGHT.accentText,
        },
        '.darkTheme &': {
            backgroundColor: SV_DARK.accent,
            color: SV_DARK.accentText,
        },
    },
    name: {
        fontSize: '15px',
        lineHeight: '20px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    arrow: {
        fontSize: '18px',
        flexShrink: 0,
        '.lightTheme &': {
            color: SV_LIGHT.text2,
        },
        '.darkTheme &': {
            color: SV_DARK.text2,
        },
    },
    chevron: {
        fontSize: '20px',
        flexShrink: 0,
        opacity: 0,
        transition: 'opacity .18s ease',
        '.lightTheme &': {
            color: SV_LIGHT.accent,
        },
        '.darkTheme &': {
            color: SV_DARK.accent,
        },
    },
}
